
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "portals-platform-reference-fe",
  currentProjectVersion: "static-1.1614",
  depVersions: {
  "portals-platform-reference-fe": "static-1.1614",
  "portals-platform-bend-plugin": "static-1.27",
  "apollo-dlb": "static-3.98",
  "client-types": "static-1.511",
  "foundations-assets": "static-1.5370",
  "foundations-theming": "static-1.4972",
  "foundations-theming-base": "static-1.3957",
  "foundations-theming-specialty": "static-1.2688",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8521",
  "hub-http-shared-msw-handlers": "static-1.10920",
  "hubspot-dlb": "static-2.1911",
  "react-dlb": "static-1.94",
  "video-player-core": "static-1.21",
  "data-fetching-client": "static-1.10123",
  "enviro": "static-4.455",
  "foundations-components": "static-1.8763",
  "hub-http": "static-1.6689",
  "HubStyleTokens": "static-2.11970",
  "I18n": "static-7.1709",
  "js-cookie": "static-1.18",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1705",
  "quartz-config": "static-1.1445",
  "quartz-core": "static-1.6886",
  "quartz-routing": "static-1.1097",
  "quick-fetch": "static-1.4236",
  "react": "static-7.203",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.17220",
  "rpc-client-utils": "static-1.5152",
  "ui-addon-react-router-dom": "static-1.10007",
  "UIComponents": "static-3.8916",
  "usage-tracker": "static-1.7807",
  "usage-tracker-anonymous": "static-1.6224",
  "usage-tracker-core": "static-1.7657",
  "apollo-stack-hubspot": "static-3.94",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4383",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3944",
  "quartz-webpack": "static-1.3891",
  "bend-plugin-quartz-routing": "static-1.745",
  "bender-build-tools": "static-1.3600",
  "webpack-env": "static-1.54",
  "bend-plugin-foundations-theming": "static-1.3455",
  "framer-motion": "static-1.84",
  "hs-story-utils": "static-1.9910",
  "react-utils": "static-2.5661",
  "StyleGuideUI": "static-3.518",
  "stylex": "static-1.46",
  "HeadJS": "static-2.823",
  "quartz": "static-1.7667",
  "hs-test-utils-bend-plugin": "static-1.3632",
  "msw": "static-1.103",
  "msw-config": "static-1.30",
  "testing-library": "static-1.164",
  "ts-schema": "static-1.4399",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.93",
  "bend-plugin-foundations-components": "static-1.5032",
  "floating-ui": "static-1.68",
  "react-aria": "static-1.77",
  "react-create-root-preference": "static-1.104",
  "react-select-plus": "static-1.118",
  "react-virtualized": "static-2.112",
  "tanstack-table": "static-1.66",
  "trellis-assets": "static-1.3106",
  "ui-fonts": "static-1.1232",
  "ui-images": "static-2.1277",
  "hs-locale-management": "static-1.405",
  "i18n-data": "static-1.234",
  "moment-timezone": "static-5.96",
  "interframe": "static-3.5224",
  "pdf-js": "static-2.49",
  "ui-addon-i18n": "static-1.11628",
  "usage-tracker-multi": "static-1.6221",
  "opentelemetry-fe-types": "static-1.274",
  "dispatcher": "static-1.147",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.908",
  "hubspotter-http": "static-1.4980",
  "icons": "static-2.703",
  "jasmine": "static-4.4790",
  "jasmine-runner": "static-1.6935",
  "mobile-manifest-mixins": "static-1.607",
  "module-federation": "static-1.38",
  "opentelemetry-fe": "static-1.649",
  "quartz-auth": "static-1.1342",
  "quartz-head": "static-1.1332",
  "quartz-i18n": "static-1.1342",
  "quartz-test": "static-1.1342",
  "quartz-tracking": "static-1.1046",
  "trellis-components": "static-1.3125",
  "usage-tracker-container": "static-1.7797",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.183",
  "web-vitals": "static-1.19",
  "bend-plugin-chirp-manifest": "static-1.562",
  "chirp-fetch": "static-1.2387",
  "cssUtils": "static-1.1105",
  "HubStyle": "static-2.12277",
  "react-input-autosize": "static-2.17",
  "stylex-utils": "static-1.176",
  "trellis-theming": "static-1.1492",
  "foundations-components-test-utils": "static-1.6246",
  "SharedI18nStrings": "static-1.188",
  "usage-tracker-public": "static-1.7618",
  "opentelemetry-web": "static-1.23",
  "sassPrefix": "static-1.371",
  "hubspotter-http-shared-msw-handlers": "static-1.10918",
  "usage-tracker-session-replay": "static-1.5493",
  "base-ui": "static-1.29",
  "react-day-picker": "static-1.15",
  "tanstack-virtual": "static-1.43",
  "foundations-components-legacy": "static-1.1788",
  "amplitude-session-replay-browser": "static-1.60"
},
  depPathPrefixes: {
  "portals-platform-reference-fe": "/portals-platform-reference-fe/static-1.1614",
  "portals-platform-bend-plugin": "/portals-platform-bend-plugin/static-1.27",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "client-types": "/client-types/static-1.511",
  "foundations-assets": "/foundations-assets/static-1.5370",
  "foundations-theming": "/foundations-theming/static-1.4972",
  "foundations-theming-base": "/foundations-theming-base/static-1.3957",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2688",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8521",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10920",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "react-dlb": "/react-dlb/static-1.94",
  "video-player-core": "/video-player-core/static-1.21",
  "data-fetching-client": "/data-fetching-client/static-1.10123",
  "enviro": "/enviro/static-4.455",
  "foundations-components": "/foundations-components/static-1.8763",
  "hub-http": "/hub-http/static-1.6689",
  "HubStyleTokens": "/HubStyleTokens/static-2.11970",
  "I18n": "/I18n/static-7.1709",
  "js-cookie": "/js-cookie/static-1.18",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1705",
  "quartz-config": "/quartz-config/static-1.1445",
  "quartz-core": "/quartz-core/static-1.6886",
  "quartz-routing": "/quartz-routing/static-1.1097",
  "quick-fetch": "/quick-fetch/static-1.4236",
  "react": "/react/static-7.203",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.17220",
  "rpc-client-utils": "/rpc-client-utils/static-1.5152",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10007",
  "UIComponents": "/UIComponents/static-3.8916",
  "usage-tracker": "/usage-tracker/static-1.7807",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6224",
  "usage-tracker-core": "/usage-tracker-core/static-1.7657",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3944",
  "quartz-webpack": "/quartz-webpack/static-1.3891",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.745",
  "bender-build-tools": "/bender-build-tools/static-1.3600",
  "webpack-env": "/webpack-env/static-1.54",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3455",
  "framer-motion": "/framer-motion/static-1.84",
  "hs-story-utils": "/hs-story-utils/static-1.9910",
  "react-utils": "/react-utils/static-2.5661",
  "StyleGuideUI": "/StyleGuideUI/static-3.518",
  "stylex": "/stylex/static-1.46",
  "HeadJS": "/HeadJS/static-2.823",
  "quartz": "/quartz/static-1.7667",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3632",
  "msw": "/msw/static-1.103",
  "msw-config": "/msw-config/static-1.30",
  "testing-library": "/testing-library/static-1.164",
  "ts-schema": "/ts-schema/static-1.4399",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.93",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5032",
  "floating-ui": "/floating-ui/static-1.68",
  "react-aria": "/react-aria/static-1.77",
  "react-create-root-preference": "/react-create-root-preference/static-1.104",
  "react-select-plus": "/react-select-plus/static-1.118",
  "react-virtualized": "/react-virtualized/static-2.112",
  "tanstack-table": "/tanstack-table/static-1.66",
  "trellis-assets": "/trellis-assets/static-1.3106",
  "ui-fonts": "/ui-fonts/static-1.1232",
  "ui-images": "/ui-images/static-2.1277",
  "hs-locale-management": "/hs-locale-management/static-1.405",
  "i18n-data": "/i18n-data/static-1.234",
  "moment-timezone": "/moment-timezone/static-5.96",
  "interframe": "/interframe/static-3.5224",
  "pdf-js": "/pdf-js/static-2.49",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11628",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6221",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.274",
  "dispatcher": "/dispatcher/static-1.147",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.908",
  "hubspotter-http": "/hubspotter-http/static-1.4980",
  "icons": "/icons/static-2.703",
  "jasmine": "/jasmine/static-4.4790",
  "jasmine-runner": "/jasmine-runner/static-1.6935",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.607",
  "module-federation": "/module-federation/static-1.38",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.649",
  "quartz-auth": "/quartz-auth/static-1.1342",
  "quartz-head": "/quartz-head/static-1.1332",
  "quartz-i18n": "/quartz-i18n/static-1.1342",
  "quartz-test": "/quartz-test/static-1.1342",
  "quartz-tracking": "/quartz-tracking/static-1.1046",
  "trellis-components": "/trellis-components/static-1.3125",
  "usage-tracker-container": "/usage-tracker-container/static-1.7797",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.183",
  "web-vitals": "/web-vitals/static-1.19",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.562",
  "chirp-fetch": "/chirp-fetch/static-1.2387",
  "cssUtils": "/cssUtils/static-1.1105",
  "HubStyle": "/HubStyle/static-2.12277",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "stylex-utils": "/stylex-utils/static-1.176",
  "trellis-theming": "/trellis-theming/static-1.1492",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6246",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.188",
  "usage-tracker-public": "/usage-tracker-public/static-1.7618",
  "opentelemetry-web": "/opentelemetry-web/static-1.23",
  "sassPrefix": "/sassPrefix/static-1.371",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10918",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5493",
  "base-ui": "/base-ui/static-1.29",
  "react-day-picker": "/react-day-picker/static-1.15",
  "tanstack-virtual": "/tanstack-virtual/static-1.43",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1788",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60"
}
};
